app
    .controller('poViewCtrl', function ($rootScope, $scope, $q, _API_URL, $state, $window, shareData, modalFactory, modalService, $filter, urlServices, _VAR_GLOBAL, toaster, $location) {
        $scope.filter = '';
        $scope.dataList = {
            totalItems: 0,
            summary: {},
            data: []
        };
        $scope.paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };
        $scope.currentStatusFilter = null;
        $scope.perTglP = {
            startDate: moment().subtract(30, 'days'),
            endDate: moment()
        };
        $scope.approve = function (dt) {
            shareData.setDataDetails(dt);
            console.log(dt);

            modalService.showModal({}, {
                closeButtonText: 'No',
                actionButtonText: 'Yes',
                headerText: 'Approve PO ',
                bodyText: 'Approve PO : ' + dt.NoBukti
            })
            .then(function (result) {
                var dtS = shareData.getDataDetails();
                if (result) {

                    urlServices.approvePo(dtS.NoBukti, function (g, s) {
                        if (g) {
                            console.log('error');
                            toaster.pop('error', 'Error', g);
                        } else {
                            toaster.pop('success', 'sucess', s);
                            $scope.viewData(1);
                        }
                    })
                }
            });


        };
        $scope.reject = function (dt) {
            var reason = prompt('Masukkan alasan reject PO ' + dt.NoBukti + ':');
            if (!reason || !reason.trim()) {
                toaster.pop('warning', 'Peringatan', 'Alasan reject wajib diisi');
                return;
            }
            shareData.setDataDetails(dt);

            modalService.showModal({}, {
                closeButtonText: 'Batal',
                actionButtonText: 'Ya, Reject',
                headerText: 'Reject PO',
                bodyText: 'Reject PO: ' + dt.NoBukti + '\nAlasan: ' + reason
            })
            .then(function (result) {
                var dtS = shareData.getDataDetails();
                if (result) {
                    urlServices.rejectPo(dtS.NoBukti, reason, function (g, s) {
                        if (g) {
                            toaster.pop('error', 'Error', g);
                        } else {
                            toaster.pop('success', 'Berhasil', 'PO berhasil direject');
                            $scope.viewData(1);
                        }
                    });
                }
            });
        };
        $scope.buatPo = function (dt) {
            console.log(dt)
            return window.location = _API_URL + 'potransaksi';
        };

        $scope.delete = function (dt) {
            modalService.showModal({}, {
                closeButtonText: 'Batal',
                actionButtonText: 'Ya, Hapus',
                headerText: 'Hapus PO',
                bodyText: 'Anda yakin ingin menghapus PO ' + dt.NoBukti + '?'
            }).then(function (result) {
                if (result) {
                    urlServices.simpanData('api/po/delete', { NoBukti: dt.NoBukti }, function (err, res) {
                        if (err) {
                            toaster.pop('error', 'Error', err.err || err);
                        } else {
                            toaster.pop('success', 'Sukses', 'PO berhasil dihapus');
                            $scope.viewData(1);
                        }
                    });
                }
            });
        };


        $scope.viewData = function (pg, qry) {
            console.log($scope.filter);
            if (typeof qry !== 'undefined') {
                $scope.currentStatusFilter = qry;
            }
            $scope.paginationOptions.pageNumber = pg;
            $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter, $scope.currentStatusFilter);
        };
        $scope.detail = function (n) {
            modalFactory.open('lg', 'modal.list.html', 'modalListCtrl', {
                functionName: 'poViewList',
                params: {
                    no: n.NoBukti
                }
            });
        };
        $scope.viewDashboard = function () {
            urlServices.ambilData('api/po/summary?start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd"), {}, function (e, s) {
                console.log('dashboard');
                console.log(s);
                console.log(e);
                if (e) {
                    $scope.dataList.summary = {};
                } else {
                    $scope.dataList.summary = s[0];
                }
            });
        };
        $scope.getData = function (pageSize, page, searchText, qry) {
            var qry = qry || null;
            var data;
            if (searchText) {
                var ft = searchText.toLowerCase();
                data = 'term=' + ft + '&limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry) data += '&status=' + qry;
            } else {
                data = 'limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                if (qry) data += '&status=' + qry;
            }

            var sdate = $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd");
            var edate = $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");

            // page 1: summary + list paralel; page > 1: list only
            if (page === 1) {
                $q.all({
                    summary: urlServices.ambilDataPromise('api/po/summary?start_date=' + sdate + '&end_date=' + edate),
                    list: urlServices.ambilDataPromise('api/po/filter?' + data)
                }).then(function (results) {
                    if (results.summary && !results.summary.err) {
                        $scope.dataList.summary = results.summary[0] || {};
                    }
                    if (results.list && !results.list.err) {
                        $scope.dataList.totalItems = results.list.records || 0;
                        $scope.dataList.data = results.list.data || [];
                    } else {
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = [];
                    }
                }, function (err) {
                    toaster.pop('error', 'Error', err);
                });
            } else {
                urlServices.ambilData('api/po/filter?' + data, {}, function (err, result) {
                    if (err || (result && result.err)) {
                        toaster.pop('error', 'Error', err || result.err);
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = [];
                        return;
                    }
                    $scope.dataList.totalItems = result.records || 0;
                    $scope.dataList.data = result.data || [];
                });
            }
        };

        $scope.viewData(1);

        $scope.loadPoReasons = function (n) {
            if (!n._expanded) {
                return;
            }
            if (n._reasons) {
                return;
            }
            n._reasonsLoading = true;
            n._reasons = [];
            var poNo = String(n.NoBukti || '').trim();
            urlServices.ambilData('api/po-reason/' + encodeURIComponent(poNo), {}, function (err, result) {
                n._reasonsLoading = false;
                if (err || !result) {
                    n._reasons = [];
                } else if (Array.isArray(result)) {
                    n._reasons = result;
                } else if (result && Array.isArray(result.dt)) {
                    n._reasons = result.dt;
                } else if (result && Array.isArray(result.data)) {
                    n._reasons = result.data;
                } else if (result && Array.isArray(result.reasons)) {
                    n._reasons = result.reasons;
                } else {
                    n._reasons = [];
                }
            });
        };
    })